import { ISetDescriptionParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetWorkbookDescriptionRequest extends Request<ISetDescriptionParams, IEmptyResult> {
  constructor(id: string, description: string) {
    super('setWorkbookDescription', {
      id: id,
      description: description
    });
  }
}
